import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import Modal from '../../../shared/components/ui/Modal';
import Button from '../../../shared/components/ui/Button';
import FormInput from '../../../shared/components/ui/FormInput';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';

const ZohoIntegration = ({ onClose, onConnect, defaultValues, isSubmitting, companyId }) => {
  const userId = Cookies.get('userId');
  const { register, handleSubmit, setValue } = useForm();

  const [showClientSecret, setShowClientSecret] = useState(false);

  const toggleClientSecretVisibility = () => {
    setShowClientSecret(!showClientSecret);
  };

  useEffect(() => {
    mixpanel.track('Zoho Integration Viewed', {
      user_id: userId,
      timestamp: new Date().toISOString()
    });
  }, [userId]);

  useEffect(() => {
    if (defaultValues) {
      setValue('zoho_client_id', defaultValues.zoho_client_id);
      setValue('zoho_client_secret', defaultValues.zoho_client_secret);
      setValue('zoho_organization_code', defaultValues.zoho_organization_code);
    }
  }, [defaultValues, setValue]);

  const onSubmit = (data) => {
    const payload = {
      ...data,
      company_id: companyId
    };
    onConnect(payload);
  };

  return (
    <Modal isDirty={true} confirmOnClose={true} name="Zoho Integration" onClose={onClose} width={50}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="grid grid-cols-2 gap-6 mt-5">
          <FormInput
            label="Client ID"
            register_key="zoho_client_id"
            register={register}
            isRequired={true}
            type="text"
            placeholder="Enter Client ID"
          />

          <FormInput
            label="Client Secret"
            register_key="zoho_client_secret"
            register={register}
            isRequired={true}
            type={showClientSecret ? 'text' : 'password'}
            placeholder="Enter Client Secret"
          />
          <div className="absolute right-3 top-9 text-gray-400 cursor-pointer">
            <span onClick={toggleClientSecretVisibility}>{showClientSecret ? '🙈' : '👁️'}</span>
          </div>

          <FormInput
            label="Organisation Code"
            register_key="zoho_organization_code"
            register={register}
            isRequired={true}
            type="text"
            placeholder="Enter Organisation Code"
          />
        </div>

        <div className="flex justify-end gap-4 mt-10">
          <Button displayType="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button type="submit" disabled={isSubmitting}>
            Save & Connect
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default ZohoIntegration;
